import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'

export function configureSentry(options) {
  Sentry.init({
    dsn: options.dsn,
    debug: options.debug,
    release: options.release,
    environment: options.environment,
    tracesSampleRate: options.tracesSampleRate,
    integration: [new BrowserTracing()],
  })
}
